import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import qs from 'qs'
import qrcode from 'qrcode'
import { browserHistory } from 'react-router'
import { Toast, Toptips, Dialog, Form, FormCell, CellBody, TextArea } from 'react-weui'
import { storage, isPC, showBigAvatar } from '../../utils'
import { series } from '../../utils/async'
import { WKVisible, WKBottomBtn, WkPanel } from '../../components/wk'
import {filterHTML} from "../../utils"
import closeImg from '../../images/schedule/close.png'
import addImg from '../../images/schedule/add.png'
import recordImg from '../../images/schedule/record.png'
import playImg from '../../images/schedule/play.png'
import pauseImg from '../../images/schedule/pause.png'
import '../../css/page/SchedulePage.css'


class SchduleSigninCreatePage extends React.Component {
    constructor (props) {
        super(props)
        this.MAX_IMAGES_LENGTH = 9
        this.state = {
            recordStatus: 'noCheck',
            recordId: '',
            desc: '',
            images: [],
            isPending: false,
            pendingText: '',
            recordSecond: 0,
            playSecond: 0,
            totalSecond: 0,
            signinId: '',
            imageHost: '',
            isShowQrDialog: false,
            qrImg: '',
            isShowFollowDialog: false,
            schedule: {},
            isShowDesc: true,
            isLongDesc: false,
            isShowDescWrap: true,
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            alertDialog: {
                isShow: false,
                text: '',
            },
            log: '',
            isSubscribe: false,
        }
    }
    componentDidMount () {
        document.title = '填写打卡内容'
        if (this.props.wx.ready) {
            this.tryRecord()
        }
        this.fetchSchedule()
        this.fetchSubscribeInfo()
    }
    handleDescCollapse () {
        if (!this.$descContent) {
            return null
        }
        const descContentHeight = this.$descContent.getBoundingClientRect().height
        // console.log(descContentHeight)
        this.setState({ isLongDesc: descContentHeight >= 100, isShowDesc: descContentHeight < 100 })
    }
    pollingHandleDescCollapse () {
        let i = 0
        this.timer = setInterval(() => {
            this.handleDescCollapse()
            i ++
            if (i >= 10) clearInterval(this.timer)
        }, 50)
    }
    fetchSchedule () {
        axios.get(`/api/schedule/${this.props.params.id}/info`)
            .then(res => {
                const data = res.data.data
                this.setState({ schedule: data.schedule, isShowDescWrap: !!data.schedule.description }, () => {
                    this.handleDescCollapse()
                    this.pollingHandleDescCollapse()
                })
            })
    }
    componentWillReceiveProps (props) {
        if (this.props.wx.ready !== props.wx.ready) {
            this.tryRecord()
        }
    }
    tryRecord () {
        const status = storage.getItem('audioRecorder/status')
        if (status) {
            if (status.checked && (Date.now() - status.checkTime) < 1000*86400*7) {
                this.setState({ recordStatus: 'noRecord' })
                return
            }
        }
        window.wx.startRecord({
            success: () => {
                setTimeout(()=>{
                    window.wx.stopRecord({
                        complete: (res)=>{
                            this.setState({ recordStatus: 'noRecord' })
                            storage.setItem('audioRecorder/status', {
                                checked: true,
                                checkTime: Date.now()
                            })
                        }
                    })
                }, 500)
            },
            fail: err => {
                a(err)
                this.setState({ recordStatus: 'disableRecord' })
            },
        })
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    onRecordAutoStop () {
        window.wx.onVoiceRecordEnd({
            complete: (res) => {
                clearInterval(this.recordTimer)
                this.setState({
                    recordId: res.localId, 
                    totalSecond: 60,
                    recordSecond: 60,
                    recordStatus: 'stopRecord',
                })
            }
        })
    }
    onChangeFile (e) {
        if (!e.target.files[0]) {
            return
        }
        this.setState({ isPending: true, pendingText: '上传中' })
        const formData = new FormData()
        formData.append('image', e.target.files[0])
        formData.append('mtype', 'img')
        formData.append('from', 'pc')
        axios.post('/api/upload_media', formData, {
            timeout: 20000
        })
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code) {
                    return this.showTip(res.data.msg)
                }
                if (this.state.images.indexOf(res.data.data.img) > -1) {
                    return this.showTip('重复上传照片了')
                }
                this.setState({
                    images: this.state.images.concat(res.data.data.path),
                    imageHost: res.data.data.img_url,
                })
            })
            .catch(err => {
                if (err.message.indexOf('timeout') > -1) {
                    this.showTip('上传图片超时')
                } else {
                    this.showTip('上传图片错误')
                }
            })
            .then(res => {
                this.setState({ isPending: false })
            })
    }
    onClickAdd (count = this.MAX_IMAGES_LENGTH) {
        wx.chooseImage({
            count,
            // sizeType: ['original', 'compressed'],
            sizeType: ['compressed'],
            success: (res) => {
                const localIds = res.localIds
                this.uploadImages(localIds)
            }
        })
    }
    uploadWxImages (id) {
        return (resolve, reject) => {
            wx.uploadImage({
                localId: id,
                isShowProgressTips: 0,
                success: (res) => {
                    const serverId = res.serverId
                    resolve(serverId)
                }
            })
        }
    }
    uploadImages (ids) {
        const fns = ids.map(item => this.uploadWxImages(item))
        this.setState({ isPending: true, pendingText: '上传中' })
        series(fns)
            .then(res => {
                return axios.post('/api/upload_media', qs.stringify({
                    mtype: 'img',
                    from: 'weixin',
                    content: JSON.stringify(res),
                }), {
                    timeout: 20000
                })
            })
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code) {
                    return this.showTip(res.data.msg)
                }
                this.setState({
                    images: this.state.images.concat(res.data.data.path),
                    imageHost: res.data.data.img_url,
                })
            })
    }
    onClickClose (e, image) {
        e.stopPropagation()
        if (this.$fileInput) {
            this.$fileInput.value = ''
        }
        if (this.state.images.indexOf(image) > -1) {
            this.setState({ images: this.state.images.filter(item => item !== image) })
        } else {
            this.setState({ images: this.state.images.concat(image) })
        }
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    onSubmit () {
        const desc = this.state.desc.trim()
        if (!desc && !this.state.recordId && this.state.images.length === 0) {
            return this.showTip('请填写打卡内容')
        }
        if (this.state.images.length > this.MAX_IMAGES_LENGTH) {
            return this.showTip(`图片不能超过${this.MAX_IMAGES_LENGTH}张`)
        }
        this.setState({ isPending: true, pendingText: '正在打卡' })
        if (this.state.recordId) {
            window.wx.uploadVoice({
                localId: this.state.recordId,
                isShowProgressTips: 0,
                success: (res) => {
                    axios.post(`/api/upload_media`, qs.stringify({
                        mtype: 'audio',
                        from: 'weixinhd',
                        content: res.serverId
                    }))
                        .then(audio => {
                            if (audio.data.code !== 0) {
                                return this.showTip(audio.data.msg)
                            }
                            this.submitData(desc, audio, this.state.images)
                        })
                        .catch(err => {
                            a(err.message)
                            alert('上传录音失败，请重试')
                        })
                        .then(res => {
                            this.setState({ isPending: false })
                        })
                },
                fail: (res) => {
                    a(res)
                    alert('上传录音失败，请重试')
                    this.setState({ isPending: false })
                },
            })
        } else {
            this.submitData(desc, '', this.state.images)
        }
    }
    submitData (desc, audio, images) {
        axios.post(`/api/schedule/${this.props.params.id}/publish_signin`, qs.stringify({
            content: desc,
            audio: audio ? audio.data.data.path : '',
            audio_length: audio ? audio.data.data.length : '',
            images: JSON.stringify(images),
        }))
            .then(res => {
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                if (this.state.isSubscribe) {
                    this.showAlert('发布成功')
                } else {
                    axios.post(`/api/schedule/${this.props.params.id}/signup_qrcode`)
                        .then(res => {
                            this.toQrImg(res.data.data.qrcode_content)
                        })
                    this.setState({ isShowFollowDialog: true })
                }
                this.setState({ signinId: res.data.data.id })
            })
            .catch(err => {
                if (err.response.status === 403) {
                    alert('无打卡权限')
                }
                a(err.message)
                alert('服务器繁忙，请稍后再试')
            })
            .then(res => {
                this.setState({ isPending: false })
            })
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    onClickSuccessOk () {
        this.setState({ alertDialog: { isShow: false } })
        this.handleSigninSuccess()
    }
    onClickRecord () {
        window.wx.startRecord({
            success: res => {
                this.onRecordAutoStop()
                this.recordTimer = setInterval(() => {
                    this.setState({ recordSecond: this.state.recordSecond + 0.1 })
                }, 100)
            },
        })
        this.setState({ recordStatus: 'recording' })
    }
    onClickStopRecord () {
        clearInterval(this.recordTimer)
        window.wx.stopRecord({
            success: (res) => {
                this.setState({
                    recordId: res.localId, 
                    totalSecond: this.state.recordSecond,
                    recordSecond: 0,
                    recordStatus: 'stopRecord',
                })
            }
        })
    }
    onClickPlayRecord () {
        window.wx.playVoice({
            localId: this.state.recordId,
            success: res => {
                this.playTimer = setInterval(() => {
                    this.setState({ playSecond: this.state.playSecond + 0.1, recordStatus: 'playing' }, () => {
                        if (this.state.playSecond >= this.state.totalSecond) {
                            clearInterval(this.playTimer)
                            this.setState({ playSecond: 0, recordStatus: 'stop' })
                        }
                    })
                }, 100)
            },
        })
    }
    onClickStopPlay () {
        window.wx.stopVoice({
            localId: this.state.recordId,
            success: res => {
                clearInterval(this.playTimer)
                this.setState({ playSecond: 0, recordStatus: 'stop' })
            },
        })
    }
    onClickRecordBar () {
        const recordStatus = this.state.recordStatus
        if (recordStatus === 'noCheck' || recordStatus === 'disableRecord') {
            return
        }
        if (recordStatus === 'noRecord') {
            this.onClickRecord()
        }
        if (recordStatus === 'recording') {
            this.onClickStopRecord()
        }
        if (recordStatus === 'stopRecord') {
            this.onClickPlayRecord()
        }
        if (recordStatus === 'playing') {
            this.onClickStopPlay()
        }
        if (recordStatus === 'stop') {
            this.onClickPlayRecord()
        }
    }
    getRecordBarInfo () {
        switch (this.state.recordStatus) {
            case 'noCheck':
                return {
                    text: '录音正在初始化...',
                    img: recordImg,
                }
            case 'noRecord':
                return {
                    text: '点击一下开始录音',
                    img: recordImg,
                }
            case 'recording':
                return {
                    text: '再次点击完成录音',
                    img: '',
                }
            case 'stopRecord':
                return {
                    text: '',
                    img: playImg,
                }
            case 'playing':
                return {
                    text: '',
                    img: pauseImg,
                }
            case 'stop':
                return {
                    text: '',
                    img: playImg,
                }
            case 'disableRecord':
                return {
                    text: '设备无法录音，请刷新重试',
                    img: recordImg,
                }
            default:
                return {
                    text: '设备无法录音，请刷新重试',
                    img: recordImg,
                }
        }
    }
    toQrImg (str) {
        qrcode.toDataURL(str, {
            errorCorrectionLevel: 'M',
            margin: 2,
            type: 'image/png',
        }, (err, url) => {
            if (err) throw err
            this.setState({ qrImg: url })
        })
    }
    onClickReRecordBar () {
        clearInterval(this.playTimer)
        window.wx.stopVoice({
            localId: this.state.recordId,
        })
        this.setState({
            totalSecond: 0,
            playSecond: 0,
            recordSecond: 0,
            recordStatus: 'noRecord',
        })
        this.onClickRecord()
    }
    onClickQrOk () {
        this.setState({ isShowQrDialog: false })
        this.handleSigninSuccess()
    }
    handleSigninSuccess () {
        // browserHistory.replace(`/schedule/${this.props.params.id}`)
        // browserHistory.go(-1)
        storage.setItem('schedule_create', true)
        if (window.systemType === 'android') {
            history.go(-1)
        } else {
            browserHistory.go(-1)
        }
    }
    fetchSubscribeInfo () {
        axios.get('/api/schedule/subscribe/info')
            .then(res => {
                this.setState({ isSubscribe: res.data.data.subscribed })
            })   
    }
    onClickDescBottom (isShowDesc) {
        this.setState({ isShowDesc: !isShowDesc })
    }
    render() {
        const recordStatus = this.state.recordStatus
        const playPercent = this.state.playSecond / this.state.totalSecond * 100
        const isWxPhone = window.platform === 'weixin' && !isPC()
        const isSdkLoad = this.props.wx.ready && this.state.recordStatus !== 'disableRecord'
        const schedule = this.state.schedule
        const { isShowDesc, isLongDesc, isShowDescWrap } = this.state
        return (
            <div className="schdule-signin-create-page wk-page">
                {/* 介绍板块 */}
                <WKVisible create={isShowDescWrap}>
                    <WkPanel 
                        className={`intro-wrap ${isShowDesc ? 'is-show' : 'is-hide'} ${isLongDesc ? 'long-desc' : ''}`} 
                        title='活动介绍' 
                        isHideTip={isShowDesc || !schedule.description}
                        // tip={ <span onClick={e => this.setState({ isShowDesc: true })}>查看详情</span> }
                    >
                        <div className='desc-content-wrap'>
                            <div ref={r => this.$descContent = r} dangerouslySetInnerHTML={{__html: filterHTML(schedule.description)}}></div>
                        </div>
                        <WKVisible create={isLongDesc}>
                            <div className="more" onClick={e => this.onClickDescBottom(isShowDesc)}>
                                {isShowDesc ? '>> 点击收起 <<' : '>> 点击展开 <<'}
                            </div>
                        </WKVisible>
                    </WkPanel>
                </WKVisible>
                
                {/* 填写打卡内容区 */}
                <div className={`textarea-wrap ${isShowDesc ? '' : 'is-no-border'}`}>
                    <Form>
                        <FormCell>
                            <CellBody>
                                <TextArea 
                                    value={this.state.desc} 
                                    placeholder="请输入打卡内容..." 
                                    rows="7" 
                                    showCounter={false}
                                    onChange={e => this.bindValue(e, 'desc')}
                                >
                                </TextArea>
                            </CellBody>
                        </FormCell>
                    </Form>
                </div>

                {/* 图片区 */}
                <div className='upload-wrap margin-bottom'>
                    {
                        this.state.images.map(item => (
                            <div className="upload-item" key={item}>
                                <img onClick={e => showBigAvatar(this.state.imageHost + item)} className='image' src={this.state.imageHost + item} />
                                <div className="close" onClick={e => this.onClickClose(e, item)}>
                                    <img src={closeImg} />
                                </div>
                            </div>
                        ))
                    }
                    <WKVisible show={this.state.images.length < this.MAX_IMAGES_LENGTH}>
                        <div className="upload-item">
                            <div 
                                onClick={e => this.onClickAdd(this.MAX_IMAGES_LENGTH - this.state.images.length)} 
                                className="add-img" 
                                style={{backgroundImage: `url(${addImg})`}}
                            >
                            </div>
                            {
                                (!isWxPhone || !isSdkLoad) && (
                                    <input type="file" ref={r => this.$fileInput = r} onChange={e => this.onChangeFile(e)} accept="image/gif,image/jpeg,image/jpg,image/png,image/bmp" />
                                )
                            }
                        </div>
                    </WKVisible>
                </div>
                {/* 录音区 */}
                <WKVisible 
                    create={isWxPhone}
                    className="record-wrap"
                >
                    {/* 录音按钮 */}
                    <div className="record-bar" onClick={e => this.onClickRecordBar(e)}>
                        <WKVisible show={this.getRecordBarInfo().img}>
                            <img src={this.getRecordBarInfo().img} />
                        </WKVisible>
                        <WKVisible show={recordStatus === 'recording'}>
                            <p className="second">{~~this.state.recordSecond}s</p>
                        </WKVisible>
                        <WKVisible 
                            className={`text ${recordStatus === 'recording' ? 'green' : ''}`} 
                            show={this.getRecordBarInfo().text}
                        >
                            {this.getRecordBarInfo().text}
                        </WKVisible>
                        <WKVisible className='progress-wrap' show={!this.getRecordBarInfo().text}>
                            <div className="progress">
                                <div 
                                    className="real-progress" 
                                    style={{width: `${playPercent <= 100 ? playPercent : 100}%`}}
                                >
                                </div>
                            </div>
                        </WKVisible>
                        <WKVisible show={!this.getRecordBarInfo().text}>
                            <div className="total-second">{~~this.state.totalSecond}''</div>
                        </WKVisible>
                    </div>
                    {/* 重新录音按钮 */}
                    <WKVisible 
                        show={!this.getRecordBarInfo().text}
                        className='margin-top'
                    >
                        <div className="record-bar" onClick={e => this.onClickReRecordBar(e)}>
                            <img src={recordImg} />
                            <p className='text green'>
                                重新录音
                            </p>
                        </div>
                    </WKVisible>
                </WKVisible>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                <Toast icon="loading" show={this.state.isPending}>{this.state.pendingText}</Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickSuccessOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Dialog type="ios" title='发布成功' buttons={[
                    { label: '关闭', onClick: () => this.onClickQrOk() }
                ]} show={this.state.isShowFollowDialog}>
                    <div className="qr-dialog">
                        <div className="text margin-bottom">
                            长按扫码，接收打卡提醒
                        </div>
                        <img src={this.state.qrImg} />
                    </div>
                </Dialog>
                <WKBottomBtn btnContent={{
                    text: '打卡',
                    method: () => {
                        this.onSubmit()
                    }}}
                />
            </div>
        )
    }
}

function a(s) {
    console.log(s)
    // alert(JSON.stringify(s))
}


export default connect(state => ({
    wx: state.wechat,
    account: state.account,
}))(SchduleSigninCreatePage)


// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleSigninCreatePage.js